const base = import.meta.env.BASE_URL.replace(/\/$/, '');

export function asset(path: string) {
  return `${base}/assets/${path.replace(/^\//, '')}`;
}

export function optimized(slug: string, width: number, format: 'webp' | 'avif' = 'webp') {
  return asset(`images/optimized/${slug}-${width}.${format}`);
}
